import React from "react";
import Header from "../../components/Header";
import AdminCointainer from "../../containers/Admin";
import { dashboard } from "../../common/svg";
import UnderConstruction from "../../components/UnderConstruction/UnderConstruction";
const Dashboard = () => {
  return (
    <div>
      <Header icon={dashboard} title="Dashboard" showSearch={false} />
      <div className="">
        <AdminCointainer>
          <UnderConstruction />
          {/* <MapComponent/> */}
          {/* <FetchSVGs/> */}
          {/* <SecureImage
         
        fileKey="InstagramVerificationBadge.svg" 
        expiresIn={600} 
        alt="Avg Speed Icon" 
        width="" 
      /> */}
          {/* <FileViewer
        bucketName="motosop-uploads"
        fileKey="58c29832-acf7-4ee0-a236-0cad7802f453/Squirrel-UpdateSelf.log"
      /> */}
        </AdminCointainer>
      </div>
    </div>
  );
};

export default Dashboard;
